import { put, takeEvery } from 'redux-saga/effects';
import Store from 'store';
import { hasFeature } from 'utils/featureFlags';
import { initLanguageFailure, initLanguageSuccess } from './actions';
import { LANGUAGE_INIT, LANGUAGE_UPDATE } from './types';

function* languageInitSaga() {
  try {
    let localeId = 'en';
    if (hasFeature('enable-language-settings')) {
      localeId = Store.get('moka:localeId', 'id');
      Store.set('moka:localeId', localeId);
    } else {
      Store.remove('moka:localeId');
    }

    yield put(initLanguageSuccess(localeId));
  } catch (error) {
    yield put(initLanguageFailure(error));
  }
}

function* languageUpdateSaga(action) {
  const { localeId } = action.payload;
  Store.set('moka:localeId', localeId);
}

export default function* saga() {
  yield takeEvery(LANGUAGE_INIT, languageInitSaga);
  yield takeEvery(LANGUAGE_UPDATE, languageUpdateSaga);
}
